import {
    AccessorsMutatorsDecorator
} from "../../helpers";
import {
    TranslatableModel
} from "./translatable-model";

export class SmsTemplate extends TranslatableModel {

    static get translatableAttributes() {
        
        return [ 'name', 'message'];
    }



    static get getStandartsList(){

        return {
            'welcome': 1,
            'confirmation': 1,
            'goodbye': 1,
            'daily_perfomance': 3,
            'payment': 2,
            'reservation': 2,
            'customer_survey': 4
        };
    }

    setStatus(value){

        const statuses = {

            true: '1',
            false: '0'
        }

        if(typeof value === "boolean"){

            return statuses[value];
        }

        return value;
    }

}

AccessorsMutatorsDecorator('id', ...SmsTemplate.translatableAttributesWithLanguageAliases,'status', 'standart', 'balance', 
'recipients', 'perfomance_day', 'sending_time', 'updated_at', 'created_at', 'language', 'property', 'schedule')(SmsTemplate);


// WEBPACK FOOTER //
// ./src/pms-api/models/sms-template.model.js